import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AuthorizationService {

    static activeSession: any;

    private static _authGroups;
    private static _oneLiveMode;

    static set authGroups(authGroups) {
        AuthorizationService._authGroups = authGroups;
    }

    static set oneLiveMode(value) {
        AuthorizationService._oneLiveMode = value;
    }

    static validForMonitorLinkOrOneLiveTenantUserOrGroupUsers = () => {
        return AuthorizationService.validationAccordingToMode({
            ovoc: AuthorizationService._authGroups.TENANT_MONITORING_LINKS,
            oneLive: [
                AuthorizationService._authGroups.tenant_user,
                AuthorizationService._authGroups.end_customer_operator,
                AuthorizationService._authGroups.channel_operator
            ]});
    };

    static validForSystemOperatorOrTenantOperatorInStandardMode = () => {
        return AuthorizationService.validationAccordingToMode({
            ovoc: AuthorizationService._authGroups.admin_operator,
            oneLive: AuthorizationService._authGroups.system_admin_operator
        });
    };

    static validForServiceProvider = () => {
        return AuthorizationService.validationAccordingToMode({ovoc: 'none', oneLive: AuthorizationService._authGroups.tenant_user});
    };

    static validForChannel = () => {
        return AuthorizationService.validationAccordingToMode({ovoc: 'none', oneLive: AuthorizationService._authGroups.channel_operator});
    };

    static validForEndCustomer = () => {
        return AuthorizationService.validationAccordingToMode({ovoc: 'none', oneLive: AuthorizationService._authGroups.end_customer_operator});
    };

    static validationAccordingToMode = ({ovoc, oneLive}) => {
        return AuthorizationService.validFor(AuthorizationService._oneLiveMode ? oneLive : ovoc);
    };

    static validFor = (securityGroups: any): boolean => {
        if (!AuthorizationService.activeSession) {
            return false;
        }

        if(securityGroups === 'none'){
            return false;
        }

        if(securityGroups === 'all'){
            return true;
        }

        if (Array.isArray(securityGroups)) {
            return securityGroups.some(securityGroup => {
                if(Array.isArray(securityGroup)){
                    return securityGroup.some(subSecurityGroup => AuthorizationService.validateSecurityLevel(subSecurityGroup));
                }

                return AuthorizationService.validateSecurityLevel(securityGroup);
            });
        }

        return AuthorizationService.validateSecurityLevel(securityGroups);
    };

    static validateSecurityLevel = (securityGroup) => {
        return AuthorizationService._authGroups[securityGroup].includes(AuthorizationService.activeSession.securityLevel);
    };

    public isSameUserConnected = (name, authType) => {
        const loggedUser = AuthorizationService.activeSession;

        return loggedUser.name === name && loggedUser.operatorAuthenticationMode === authType;
    };

}
